/* Cart Upsells – inline refresh (no page reload) */
(function(){
  /* ---- helpers ---- */
  function getSectionId(){
    var d = document.querySelector('cart-drawer-component');
    if(!d) return null;
    var s = d.closest('[id^="shopify-section"]');
    return s ? s.id.replace('shopify-section-','') : null;
  }

  function refreshDrawer(){
    var sid = getSectionId();
    if(!sid) return;
    fetch('/?sections='+sid)
      .then(function(r){return r.json()})
      .then(function(data){
        var html = data[sid];
        if(!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html,'text/html');

        /* replace cart-items */
        var oldItems = document.querySelector('cart-items-component');
        var newItems = doc.querySelector('cart-items-component');
        if(oldItems && newItems) oldItems.innerHTML = newItems.innerHTML;

        /* replace summary (totals + button) */
        var oldSum = document.querySelector('.cart-drawer__summary');
        var newSum = doc.querySelector('.cart-drawer__summary');
        if(oldSum && newSum) oldSum.innerHTML = newSum.innerHTML;

        /* replace upsells block */
        var oldUp = document.querySelector('.cart-upsells');
        var newUp = doc.querySelector('.cart-upsells');
        if(oldUp && newUp) oldUp.outerHTML = newUp.outerHTML;

        /* update header cart count */
        var oldBubble = document.querySelector('.cart-count-bubble, [data-cart-count]');
        var newBubble = doc.querySelector('.cart-count-bubble, [data-cart-count]');
        if(oldBubble && newBubble) oldBubble.outerHTML = newBubble.outerHTML;
        else if(!oldBubble && newBubble){
          var icon = document.querySelector('.header__icon--cart, a[href="/cart"]');
          if(icon) icon.insertAdjacentHTML('beforeend', newBubble.outerHTML);
        }

        /* re-run detection */
        window.__upsellCheck();
      });
  }

  /* ---- toggle (add / remove) ---- */
  window.__upsellToggle = function(cb){
    var item = cb.closest('.cart-upsell');
    if(!item) return;
    var vid = item.dataset.vid;
    item.classList.add('cart-upsell--busy');

    if(cb.checked){
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:parseInt(vid),quantity:1}]})
      }).then(function(){ refreshDrawer(); })
        .catch(function(){ item.classList.remove('cart-upsell--busy'); cb.checked=false; });
    } else {
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:vid,quantity:0})
      }).then(function(){ refreshDrawer(); })
        .catch(function(){ item.classList.remove('cart-upsell--busy'); cb.checked=true; });
    }
  };

  /* ---- detect upsells already in cart ---- */
  window.__upsellCheck = function(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var vids = cart.items.map(function(i){return i.variant_id.toString()});
      document.querySelectorAll('.cart-upsell').forEach(function(el){
        var vid = el.dataset.vid;
        if(vids.indexOf(vid) !== -1){
          el.classList.add('cart-upsell--in-cart');
          var cb = el.querySelector('.cart-upsell__cb');
          if(cb) cb.checked = false;
        } else {
          el.classList.remove('cart-upsell--in-cart');
          el.classList.remove('cart-upsell--busy');
        }
      });
    });
  };

  /* ---- init ---- */
  document.addEventListener('DOMContentLoaded', function(){
    window.__upsellCheck();
    var drawer = document.querySelector('cart-drawer-component');
    if(drawer){
      new MutationObserver(function(){ window.__upsellCheck(); })
        .observe(drawer, {childList:true, subtree:true});
    }
  });
})();
